import { Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ManagementPageStatus } from '@ui/interfaces'
import { ExtraParams } from '@ui/interfaces/navigation'
import { Management } from '@ui/pages/manage'
import { RouteNamesEnum } from '@ui/router/routes'

export const OrganizationRoutes = () => {
  return {
    path: '/manage',
    element: <Outlet />,
    children: [
      {
        name: RouteNamesEnum.MANAGE_HOME,
        path: ':orgId',
        element: <Management />,
      },
      {
        name: RouteNamesEnum.MANAGE_MEMBERS,
        path: ':orgId/members',
        element: <Management initialState={ManagementPageStatus.MEMBERS} />,
        handle: {
          crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to={`/members`} label="Members" />,
        },
      },
      {
        name: RouteNamesEnum.MANAGE_INSTANCES,
        path: ':orgId/instances',
        element: <Management initialState={ManagementPageStatus.INSTANCES} />,
        handle: {
          crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to={`/instances`} label="Instances" />,
        },
      },
      {
        name: RouteNamesEnum.INGRESS,
        path: ':orgId/ingress',
        element: <Management initialState={ManagementPageStatus.INGRESS} />,
        handle: {
          crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to={`/ingress`} label="Ingress" />,
        },
      },
    ],
  }
}
